module.exports = __webpack_public_path__ + "static/img/s6.370a981.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/s6.png
// module id = RC0c
// module chunks = 0